import { useContext } from "react";
import { ProductContext } from "./ProductForm";

const STATES = {
  isActive: "Active",
  isActiveForBiz: "Active for BIZ",
  isSalable: "Salable",
  isPurchasable: "Purchasable",
};

const StateView = () => {
  const { product, setProduct } = useContext(ProductContext);

  return (
    <div className="card">
      <h5>State</h5>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            {Object.entries(STATES).map(([key, label]) => (
              <tr
                key={key}
                className="border-y border-gray-100 dark:border-gray-700"
              >
                <td>
                  <label htmlFor={key}>{label}: </label>
                </td>
                <td className="text-right">
                  <input
                    id={key}
                    type="checkbox"
                    checked={product[key] || false}
                    onChange={() =>
                      setProduct((prev) => ({ ...prev, [key]: !prev[key] }))
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StateView;
